import { EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatSelect } from '@angular/material';
var SelectComponent = /** @class */ (function () {
    function SelectComponent() {
        this.filterControl = new FormControl();
        this.select = new EventEmitter();
        this.translate = false;
        this.filterable = true;
        this.clear = true;
        this.displayFn = function (item) { return item.name; };
    }
    Object.defineProperty(SelectComponent.prototype, "items", {
        set: function (options) {
            if (options) {
                this.initFilter();
                this.options = options;
            }
        },
        enumerable: true,
        configurable: true
    });
    SelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.control.valueChanges.subscribe(function (value) {
            _this.select.emit(value);
        });
    };
    SelectComponent.prototype.onClear = function () {
        this.control.setValue(null);
        this.matSelect.close();
    };
    SelectComponent.prototype.initFilter = function () {
        var _this = this;
        this.filteredItems = this.filterControl.valueChanges.pipe(startWith(''), map(function (filterBy) {
            return filterBy ? _this.filteredBy(filterBy) : _this.options.slice();
        }));
    };
    SelectComponent.prototype.filteredBy = function (filterBy) {
        var _this = this;
        if (!this.options) {
            return [];
        }
        return this.options.filter(function (item) {
            return _this.displayFn(item)
                .toLowerCase()
                .indexOf(filterBy.toLowerCase()) > -1;
        });
    };
    return SelectComponent;
}());
export { SelectComponent };
